import { render, staticRenderFns } from "./attach-list.vue?vue&type=template&id=5dffd78c&scoped=true"
import script from "./attach-list.vue?vue&type=script&lang=js"
export * from "./attach-list.vue?vue&type=script&lang=js"
import style0 from "./attach-list.vue?vue&type=style&index=0&id=5dffd78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffd78c",
  null
  
)

export default component.exports